import RoomCard from "./RoomCard";

export const roomCard = {
    init: () => {
        const loadMoreButton = document.querySelectorAll(".view__rooms");
        const cardContainer = document.getElementById("property__rooms");
        [...loadMoreButton].forEach(() => new RoomCard(cardContainer, loadMoreButton));
    }
}

export default roomCard;